import { Flex, FlexProps } from "@chakra-ui/layout";
import React, { ReactNode } from "react";

export interface ListProps extends FlexProps {
	children: ReactNode;
}

export function List({ children, ...rest }: ListProps) {
	return (
		<Flex
			w="full"
			h="full"
			overflowX="hidden"
			overflowY="auto"
			position="relative"
			flexDirection="column"
			{...rest}
		>
			<Flex flexDirection="column">{children}</Flex>
		</Flex>
	);
}
